$.lui("comp",".comp_ltip_compare_parameters",function (selector) {
    let showMoreButton = selector.find('[data-show-more]')

    showMoreButton.on('click', function(e){
        e.preventDefault();
        selector.find('.wrp_comp_body').addClass('state--active');
        showMoreButton.parent().hide();
    })
});
